import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {ConfigProvider} from 'antd';
import './i18n/config';
import './index.css';
import App from './App';
import {store} from './store/store';
import antdTheme from './theme/antdTheme';

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(
    <Provider store={store}>
        <React.StrictMode>
            <ConfigProvider theme={antdTheme}>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </ConfigProvider>
        </React.StrictMode>
    </Provider>
);
